module.exports = __webpack_public_path__ + "img/ZEN.0b1f5ab9.svg";